import { Helmet } from 'react-helmet-async';

import { useRouteMeta } from '@/shared/routes/use-route-meta';

/**
 * Sets the browser-tab title for whatever route is active.
 *
 * Mounted once above the route outlet, so pages neither import Helmet nor
 * restate the brand suffix. Helmet applies the last mounted title, and this
 * sits above the pages, so any page still rendering its own <Helmet><title>
 * continues to win, which lets the raw blocks be removed gradually.
 */
export default function DocumentTitle() {
  const { documentTitle } = useRouteMeta();

  return (
    <Helmet>
      <title>{documentTitle}</title>
    </Helmet>
  );
}
